import * as React from "react";

const Test = ({ message }) => {
    return <div>{message}</div>;
}
export default Test;